export const CAMPUS_LIST_ERROR = 'Unable to load campus data.';
